import productPackage from "../../../../package.json";

export const PRODUCT_RELEASE = Object.freeze({
  name: productPackage.nexus.codename,
  version: productPackage.version,
});

export const PRODUCT_RELEASE_LABEL = `${PRODUCT_RELEASE.version} ${PRODUCT_RELEASE.name}`;
